export type PlatformSearchHit = {
  id: string;
  title: string;
  subtitle: string | null;
  href: string;
};

export type PlatformSearchResults = {
  posts: PlatformSearchHit[];
  communities: PlatformSearchHit[];
  members: PlatformSearchHit[];
};

export const EMPTY_SEARCH_RESULTS: PlatformSearchResults = {
  posts: [],
  communities: [],
  members: [],
};

export function searchResultCount(results: PlatformSearchResults) {
  return results.posts.length + results.communities.length + results.members.length;
}
